import React from 'react';
import { useLoaderData } from 'react-router-dom';

import Descriptor from '@r6digital/rapidstor-types/react/entities/Descriptor';
import Location from '@r6digital/rapidstor-types/react/entities/Location';
import UnitType from '@r6digital/rapidstor-types/react/entities/UnitType';

import { descriptorDimensions } from '@/core/utils/rapidstor';

import { descriptorTitle, sizeLabel } from '@/features/rapidstor/helpers';

import classes from './styles.module.scss';

interface Props {
    descriptor: Descriptor;
    unitType: UnitType;
}

export default function DescriptorLabel({ descriptor, unitType }: Props) {
    const location = useLoaderData() as Location;

    const [type, title] = descriptorTitle(descriptor, location);

    return (
        <div className={`${classes.label}`}>
            {type === 0 && (
                <div className={`${classes.type_0}`}>
                    {/* title is the descriptor name from descriptorTitle (a
                    variable the rs-setting plugin can't trace); flag it as
                    RapidStor content via the runtime marker. */}
                    <span data-rs-setting-dynamic="descriptorTitle">{title}</span>
                </div>
            )}

            {type === 1 && (
                <div className={`${classes.type_1}`}>
                    <div className={`${classes.top}`}>
                        <span className={`${classes.area}`}>{title}</span>
                        <span className={`${classes.sizeLabel}`}>
                            {sizeLabel(descriptor.area, location)}
                        </span>
                    </div>
                    <span className={`${classes.dimensions}`}>
                        {descriptorDimensions(unitType, location, { parens: true, showDimensionType: true })}
                    </span>
                </div>
            )}

            {type === 2 && (
                <div className={`${classes.type_2}`}>
                    <span className={`${classes.dimensions}`}>
                        {descriptorDimensions(unitType, location)}
                    </span>
                    <div className={`${classes.bottom}`}>
                        <span className={`${classes.sizeLabel}`}>
                            {sizeLabel(descriptor.area, location)}
                        </span>
                        <span data-rs-setting-dynamic="descriptor.name">{descriptor.name}</span>
                    </div>
                </div>
            )}
        </div>
    );
}
